import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const updateLimitModalSelector = createSelector(modalsSelector, (modals) => modals.updateLimit);

export default updateLimitModalSelector;
